import { LoadingIndicatorComponent } from '../../components/loading-indicator/loading-indicator.component';
// @ts-ignore
import { CommonModule } from '@angular/common';
// @ts-ignore
import { Component, ElementRef, HostBinding, HostListener, ViewChild, signal } from '@angular/core';
// @ts-ignore
import { FormsModule } from '@angular/forms';
import { LucideAngularModule, ZoomIn, ZoomOut } from 'lucide-angular';
// @ts-ignore
import { firstValueFrom } from 'rxjs';
import { SankhyaGatewayService } from '../../services/sankhya-gateway.service';

@Component({
    selector: 'app-gpl-conferencia-cliente',
    standalone: true,
    imports: [LoadingIndicatorComponent, CommonModule, FormsModule, LucideAngularModule],
    templateUrl: './gpl-conferencia-cliente.component.html',
    styleUrl: './gpl-conferencia-cliente.component.css'
})
export class GplConferenciaClienteComponent {
    readonly ZoomIn = ZoomIn;
    readonly ZoomOut = ZoomOut;
    @ViewChild('clienteBuscaField') clienteBuscaField?: ElementRef<HTMLElement>;
    @HostBinding('class.conference-report-visible')
    get relatorioVisivel(): boolean {
        return !!this.conferencia;
    }

    carregando = signal(false);
    buscaClienteTexto = '';
    buscaDataInicial = this.formatarDataInput(this.diasAntes(new Date(), 7));
    buscaDataFinal = this.formatarDataInput(new Date());
    clientesBusca: any[] = [];
    vendasCliente: any[] = [];
    clienteSelecionado: any = null;
    dropdownClientesAberto = false;
    dropdownClienteStyle: Record<string, string> = {};
    mensagemBusca = 'Digite o CNPJ ou nome do cliente para localizar as vendas.';
    conferencia: any = null;
    itens: any[] = [];
    conferenciaZoomAtual = 1.0;
    modalImpressaoAberto = false;
    tipoImpressao: 'completa' | 'simplificada' | 'ambas' = 'completa';
    private buscaClienteTimer: ReturnType<typeof setTimeout> | null = null;

    constructor(private readonly sankhyaGateway: SankhyaGatewayService) {}

    agendarBuscaClientes(): void {
        if (this.buscaClienteTimer) {
            clearTimeout(this.buscaClienteTimer);
        }

        this.buscaClienteTimer = setTimeout(() => this.buscarClientes(), 250);
        this.atualizarDropdownClienteStyle();
    }

    abrirDropdownClientes(): void {
        if (this.buscaClienteTexto.trim().length < 2) {
            return;
        }

        this.dropdownClientesAberto = true;
        this.atualizarDropdownClienteStyle();
    }

    @HostListener('window:resize')
    @HostListener('window:scroll')
    atualizarDropdownClienteStyle(): void {
        if (!this.dropdownClientesAberto || !this.clienteBuscaField?.nativeElement) {
            return;
        }

        window.setTimeout(() => {
            const rect = this.clienteBuscaField?.nativeElement.getBoundingClientRect();
            if (!rect) {
                return;
            }

            this.dropdownClienteStyle = {
                position: 'fixed',
                top: `${rect.bottom + 6}px`,
                left: `${rect.left}px`,
                width: `${rect.width}px`,
                right: 'auto',
                zIndex: '10000'
            };
        });
    }

    async buscarClientes(): Promise<void> {
        const filtro = this.buscaClienteTexto.trim();
        this.clienteSelecionado = null;
        this.vendasCliente = [];
        this.conferencia = null;
        this.itens = [];

        if (filtro.length < 2) {
            this.clientesBusca = [];
            this.dropdownClientesAberto = false;
            this.mensagemBusca = 'Digite ao menos 2 caracteres para buscar o cliente.';
            return;
        }

        this.mensagemBusca = 'Buscando clientes...';
        this.dropdownClientesAberto = true;
        this.atualizarDropdownClienteStyle();

        try {
            const response: any = await this.respostaGateway(
                this.sankhyaGateway.buscarClientesImpressao({ CLIENTE: filtro })
            );

            const lista = response?.lista || response?.clientes || [];
            this.clientesBusca = this.removerClientesDuplicados(lista);
            this.mensagemBusca = this.clientesBusca.length ? '' : 'Nenhum cliente encontrado.';
            this.atualizarDropdownClienteStyle();
        } catch (e) {
            console.error('Erro ao buscar clientes para conferencia:', e);
            this.clientesBusca = [];
            this.mensagemBusca = 'Erro ao buscar clientes.';
        }
    }

    async selecionarCliente(cliente: any): Promise<void> {
        this.clienteSelecionado = cliente;
        this.buscaClienteTexto = this.labelCliente(cliente);
        this.clientesBusca = [];
        this.dropdownClientesAberto = false;
        await this.buscarVendasClienteSelecionado();
    }

    async buscarFiltro(): Promise<void> {
        if (this.clienteSelecionado) {
            await this.buscarVendasClienteSelecionado();
            return;
        }

        await this.buscarClientes();
    }

    async buscarVendasClienteSelecionado(): Promise<void> {
        if (!this.clienteSelecionado) {
            this.mensagemBusca = 'Selecione um cliente para buscar as vendas.';
            return;
        }

        const codparc = this.valorBusca(this.clienteSelecionado, 'codparc') || this.valorBusca(this.clienteSelecionado, 'CODPARC');

        if (!codparc) {
            this.mensagemBusca = 'Codigo do cliente nao localizado.';
            return;
        }

        this.mensagemBusca = 'Carregando vendas do cliente...';

        try {
            const response: any = await this.respostaGateway(
                this.sankhyaGateway.buscarVendasImpressao({
                    CODPARC: Number(codparc),
                    DTINICIAL: this.buscaDataInicial,
                    DTFINAL: this.buscaDataFinal
                })
            );

            const lista = response?.vendas || response?.lista || [];
            this.vendasCliente = Array.isArray(lista) ? lista : [];
            this.mensagemBusca = this.vendasCliente.length ? '' : 'Nenhuma venda encontrada para este cliente no periodo selecionado.';
        } catch (e) {
            console.error('Erro ao buscar vendas para conferencia:', e);
            this.vendasCliente = [];
            this.mensagemBusca = 'Erro ao buscar vendas do cliente.';
        }
    }

    async selecionarVenda(venda: any): Promise<void> {
        const nunota = this.valorBusca(venda, 'NUNOTA') || this.valorBusca(venda, 'nunota');

        if (!nunota) {
            this.mensagemBusca = 'Numero unico nao localizado na venda selecionada.';
            return;
        }

        this.carregando.set(true);
        this.mensagemBusca = '';
        this.clientesBusca = [];
        this.dropdownClientesAberto = false;

        try {
            const response: any = await this.respostaGateway(
                this.sankhyaGateway.consultarOrcamentoImpressao({ NUNOTA: Number(nunota) })
            );
            const orcamento = response?.orcamento || response;
            this.conferencia = orcamento;
            this.itens = Array.isArray(orcamento?.items) ? orcamento.items : [];
            this.dropdownClientesAberto = false;
        } catch (e) {
            console.error('Erro ao carregar conferencia:', e);
            this.conferencia = null;
            this.itens = [];
            this.mensagemBusca = 'Erro ao carregar dados da conferencia.';
        } finally {
            this.carregando.set(false);
        }
    }

    voltarParaBusca(): void {
        this.conferencia = null;
        this.itens = [];
        this.dropdownClientesAberto = false;
    }

    zoomConferencia(tipo: '+' | '-'): void {
        if (tipo === '+' && this.conferenciaZoomAtual < 1.4) {
            this.conferenciaZoomAtual += 0.1;
        }
        if (tipo === '-' && this.conferenciaZoomAtual > 0.7) {
            this.conferenciaZoomAtual -= 0.1;
        }
        this.conferenciaZoomAtual = Number(this.conferenciaZoomAtual.toFixed(1));
    }

    alternarZoomConferencia(): void {
        this.conferenciaZoomAtual = this.conferenciaZoomAtual >= 1.4 ? 1.0 : 1.4;
    }

    estiloZoomConferencia(): Record<string, string> {
        return {
            transform: `scale(${this.conferenciaZoomAtual})`,
            transformOrigin: 'top center'
        };
    }

    abrirModalImpressao(): void {
        if (!this.conferencia) return;
        this.tipoImpressao = 'completa';
        this.modalImpressaoAberto = true;
    }

    cancelarImpressao(): void {
        this.modalImpressaoAberto = false;
    }

    confirmarImpressao(): void {
        this.modalImpressaoAberto = false;
        this.imprimir();
    }

    linkPublicoPedido(data = this.conferencia): string {
        const chave = this.chavePublicaPedido(data);
        return chave ? `${this.baseUrlPedidosPublicos()}/${chave}` : this.baseUrlPedidosPublicos();
    }

    qrCodePublicoPedido(data = this.conferencia): string {
        return `https://api.qrserver.com/v1/create-qr-code/?size=96x96&data=${encodeURIComponent(this.linkPublicoPedido(data))}`;
    }

    private baseUrlPedidosPublicos(): string {
        return `${window.location.origin}/pedidos`;
    }

    private chavePublicaPedido(data: any): string {
        const nunota = this.valor(data, 'NUNOTA').replace(/\D/g, '');
        const cnpj = this.valor(data, 'CNPJ').replace(/\D/g, '');
        if (!nunota || !cnpj) return '';
        return this.base64UrlEncode(`${nunota}|${cnpj}`);
    }

    private base64UrlEncode(value: string): string {
        const bytes = new TextEncoder().encode(value);
        let binary = '';
        bytes.forEach((byte) => binary += String.fromCharCode(byte));
        return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
    }

    imprimir(): void {
        if (!this.conferencia) return;

        const styleId = 'conferencia-cliente-print-style';
        let style = document.getElementById(styleId) as HTMLStyleElement | null;

        if (!style) {
            style = document.createElement('style');
            style.id = styleId;
            style.textContent = `
                @media print {
                    body.conferencia-cliente-printing * {
                        visibility: hidden !important;
                    }

                    body.conferencia-cliente-printing app-gpl-conferencia-cliente,
                    body.conferencia-cliente-printing.conferencia-print-completa app-gpl-conferencia-cliente .conference-page,
                    body.conferencia-cliente-printing.conferencia-print-completa app-gpl-conferencia-cliente .conference-page *,
                    body.conferencia-cliente-printing.conferencia-print-simplificada app-gpl-conferencia-cliente .conference-simple-page,
                    body.conferencia-cliente-printing.conferencia-print-simplificada app-gpl-conferencia-cliente .conference-simple-page *,
                    body.conferencia-cliente-printing.conferencia-print-ambas app-gpl-conferencia-cliente .conference-page,
                    body.conferencia-cliente-printing.conferencia-print-ambas app-gpl-conferencia-cliente .conference-page *,
                    body.conferencia-cliente-printing.conferencia-print-ambas app-gpl-conferencia-cliente .conference-simple-page,
                    body.conferencia-cliente-printing.conferencia-print-ambas app-gpl-conferencia-cliente .conference-simple-page * {
                        visibility: visible !important;
                    }

                    body.conferencia-cliente-printing app-gpl-conferencia-cliente .conference-page,
                    body.conferencia-cliente-printing app-gpl-conferencia-cliente .conference-simple-page {
                        position: relative !important;
                        margin: 0 !important;
                        transform: none !important;
                        background: #fff !important;
                    }

                    body.conferencia-cliente-printing.conferencia-print-simplificada app-gpl-conferencia-cliente .conference-page,
                    body.conferencia-cliente-printing.conferencia-print-completa app-gpl-conferencia-cliente .conference-simple-page {
                        display: none !important;
                    }
                }
            `;
            document.head.appendChild(style);
        }

        const classeModo = `conferencia-print-${this.tipoImpressao}`;
        const limpar = () => {
            document.body.classList.remove('conferencia-cliente-printing');
            document.body.classList.remove(classeModo);
            window.removeEventListener('afterprint', limpar);
        };

        document.body.classList.add('conferencia-cliente-printing');
        document.body.classList.add(classeModo);
        window.addEventListener('afterprint', limpar);
        window.print();
        setTimeout(limpar, 500);
    }

    labelCliente(cliente: any): string {
        const nome = this.valorBusca(cliente, 'nomeparc') || this.valorBusca(cliente, 'NOMEPARC') || 'Cliente nao informado';
        const doc = this.valorBusca(cliente, 'docparc') || this.valorBusca(cliente, 'DOCPARC') || this.valorBusca(cliente, 'CNPJ') || this.valorBusca(cliente, 'CGC_CPF');
        return `${nome} - CNPJ: ${this.formatarDocumento(doc)}`;
    }

    numeroVenda(venda: any): string {
        const numero = this.valorBusca(venda, 'NUMNOTA').replace(/\D/g, '').padStart(7, '0');
        const data = this.valorBusca(venda, 'DTNEG');
        const ano = data.match(/\d{2}\/\d{2}\/(\d{4})/)?.[1]?.slice(-2) || '';
        return numero && ano ? `${numero}/${ano}` : numero || '-';
    }

    valorVenda(venda: any): string {
        return this.money(this.valorBusca(venda, 'VLRNOTA') || this.valorBusca(venda, 'TOTAL') || 0);
    }

    valor(data: any, key: string): string {
        return data?.[key] == null ? '' : String(data[key]);
    }

    itemPartNumber(item: any): string {
        return this.valor(item, 'PARTNUMBER') || this.valor(item, 'REFFORN') || this.valor(item, 'CODPROD') || '-';
    }

    itemCondicao(item: any): string {
        return this.valor(item, 'CONDICAO') || this.valor(item, 'CD') || 'NEW';
    }

    itemDescricao(item: any): string {
        return this.valor(item, 'DESCRPROD') || this.valor(item, 'DESCRICAO') || this.valor(item, 'DESCRICAOPROD') || 'Descricao exemplo';
    }

    itemQtd(item: any): string {
        return this.money(this.valor(item, 'QTDNEG') || this.valor(item, 'QTD') || 0);
    }

    itemQtdSimplificada(item: any): string {
        const raw = this.valor(item, 'QTDNEG') || this.valor(item, 'QTD') || '0';
        const numero = Number(String(raw).replace(/\./g, '').replace(',', '.')) || 0;
        return numero.toLocaleString('pt-BR', {
            maximumFractionDigits: 0
        });
    }

    itemFabricante(item: any): string {
        return this.valor(item, 'FABRICANTE') ||
            this.valor(item, 'fabricante') ||
            this.valor(item, 'MARCA') ||
            this.valor(item, 'marca') ||
            '-';
    }

    itemSaida(item: any): string {
        return this.itemQtd(item);
    }

    itemUnd(item: any): string {
        return this.valor(item, 'CODVOL') ||
            this.valor(item, 'codvol') ||
            this.valor(item, 'UNIDADE') ||
            this.valor(item, 'unidade') ||
            'UN';
    }

    itemSerial(item: any): string {
        return this.valor(item, 'AD_SERIAL') ||
            this.valor(item, 'SERIAL') ||
            this.valor(item, 'SERIE') ||
            this.valor(item, 'CONTROLE') ||
            '-';
    }

    itensSimplificadosColunas(): any[][] {
        const tamanhoColuna = 60;

        return [
            this.itens.slice(0, tamanhoColuna),
            this.itens.slice(tamanhoColuna, tamanhoColuna * 2),
            this.itens.slice(tamanhoColuna * 2)
        ];
    }

    prefixo(data: any): string {
        return this.valor(data, 'PREFIXO') ||
            this.valor(data, 'PREFIXO_AERO') ||
            this.valor(data, 'prefixo') ||
            this.valorPrimeiro(data, ['OBSERVACAO', 'OBS', 'AD_OBSERVACAO']).match(/Prefixo\s*:\s*([^.\s]+)/i)?.[1] ||
            '-';
    }

    tipoVenda(data: any): string {
        return this.valorPrimeiro(data, ['TIPO', 'TIPOVENDA', 'DESCROPER']) || 'NACIONAL';
    }

    statusVenda(data: any): string {
        return this.valorPrimeiro(data, ['STATUS', 'STATUSNOTA', 'STATUSNFE', 'STATUSVENDA']) || 'ESTOQUE';
    }

    enderecoFaturamento(data: any): string {
        const endereco = this.valorPrimeiro(data, ['ENDERECO', 'NOMEEND']);
        const numero = this.valorPrimeiro(data, ['NUMEND', 'NUMERO']);
        return [endereco, numero].filter(Boolean).join(' ') || '________________';
    }

    bairroCidadeCep(data: any): string {
        const bairro = this.valorPrimeiro(data, ['BAIRRO', 'NOMEBAI']);
        const cidade = this.valorPrimeiro(data, ['CIDADE', 'NOMECID']);
        const uf = this.valorPrimeiro(data, ['UF']);
        const cep = this.valorPrimeiro(data, ['CEP']);
        const cidadeUf = [cidade, uf].filter(Boolean).join('-');
        return [
            bairro ? `Bairro: ${bairro}` : '',
            cidadeUf ? `Cidade: ${cidadeUf}` : '',
            cep ? `CEP: ${this.formatarCep(cep)}` : ''
        ].filter(Boolean).join(', ') || '________________';
    }

    bairroFaturamento(data: any): string {
        return this.valorPrimeiro(data, ['BAIRRO', 'NOMEBAI']) || '________________';
    }

    cidadeUfFaturamento(data: any): string {
        const cidade = this.valorPrimeiro(data, ['CIDADE', 'NOMECID']);
        const uf = this.valorPrimeiro(data, ['UF']);
        return [cidade, uf].filter(Boolean).join('-') || '________________';
    }

    cepFaturamento(data: any): string {
        return this.formatarCep(this.valorPrimeiro(data, ['CEP'])) || '________________';
    }

    emailFaturamento(data: any): string {
        return this.valorPrimeiro(data, ['EMAILPARC', 'EMAIL']) || '';
    }

    fonesFaturamento(data: any): string {
        return this.formatarTelefones(this.valorPrimeiro(data, ['TELPARC', 'TELEFONE', 'FONE', 'FONES'])) || '________________';
    }

    volume(data: any): string {
        return this.valorPrimeiro(data, ['VOLUME', 'VOLUMES', 'QTDVOL']) || '01';
    }

    transportadora(data: any): string {
        const valor = this.valorPrimeiro(data, ['TRANSPORTADORA', 'TRANSPORTADOR', 'NOMETRANSP', 'NOMETRANSPORTADORA']);
        return valor && valor.trim().toUpperCase() !== '<SEM PARCEIRO>' ? valor : '';
    }

    tipoFrete(data: any): string {
        return this.valorPrimeiro(data, ['TIPOFRETE', 'T_FRETE', 'FRETE', 'CIF_FOB']) || 'Destinatario';
    }

    envio(data: any): string {
        return this.valorPrimeiro(data, ['ENVIO', 'FORMAENVIO', 'TIPOENVIO']) || '';
    }

    destinatario(data: any): string {
        return this.valorPrimeiro(data, ['DESTINATARIO', 'NOMEDESTINATARIO', 'PARCEIROENTREGA', 'NOMEENTREGA', 'NOMEPARC']) || '________________';
    }

    clienteEntrega(data: any): string {
        return this.valorPrimeiro(data, ['PARCEIROENTREGA', 'NOMEENTREGA', 'NOMEPARC']) || '________________';
    }

    documentoEntrega(data: any): string {
        return this.valorPrimeiro(data, [
            'CNPJENTREGA',
            'CPFENTREGA',
            'CGC_CPF_ENTREGA',
            'DOCENTREGA',
            'CNPJ'
        ]) || '________________';
    }

    enderecoEntrega(data: any): string {
        const endereco = this.valorPrimeiro(data, ['ENDENTREGA_AD', 'ENDENTREGA', 'NOMEENDENTREGA', 'NOMEEND']);
        const bairro = this.valorPrimeiro(data, ['BAIRROENTREGA', 'NOMEBAIENTREGA', 'NOMEBAI']);
        const cidade = this.valorPrimeiro(data, ['CIDADEENTREGA', 'NOMECIDENTREGA', 'NOMECID']);
        const uf = this.valorPrimeiro(data, ['UFENTREGA', 'UF']);
        const cep = this.valorPrimeiro(data, ['CEPENTREGA', 'CEP']);
        return [endereco, bairro, [cidade, uf].filter(Boolean).join('-'), cep ? `CEP ${this.formatarCep(cep)}` : '']
            .filter(Boolean)
            .join(' - ') || '________________';
    }

    enderecoEntregaLinha(data: any): string {
        const enderecoCompleto = this.valorPrimeiro(data, ['ENDENTREGA_AD', 'ENDENTREGA']);
        if (enderecoCompleto) return enderecoCompleto.split(' - ')[0] || enderecoCompleto;

        const endereco = this.valorPrimeiro(data, ['NOMEENDENTREGA', 'NOMEEND']);
        const numero = this.valorPrimeiro(data, ['NUMENDENTREGA', 'NUMEND']);
        return [endereco, numero].filter(Boolean).join(' ') || '________________';
    }

    bairroCidadeCepEntrega(data: any): string {
        const bairro = this.valorPrimeiro(data, ['BAIRROENTREGA', 'NOMEBAIENTREGA', 'NOMEBAI']);
        const cidade = this.valorPrimeiro(data, ['CIDADEENTREGA', 'NOMECIDENTREGA', 'NOMECID']);
        const uf = this.valorPrimeiro(data, ['UFENTREGA', 'UF']);
        const cep = this.valorPrimeiro(data, ['CEPENTREGA', 'CEP']);
        const cidadeUf = [cidade, uf].filter(Boolean).join('-');
        return [
            bairro ? `Bairro: ${bairro}` : '',
            cidadeUf ? `Cidade: ${cidadeUf}` : '',
            cep ? `CEP: ${this.formatarCep(cep)}` : ''
        ].filter(Boolean).join(', ') || '________________';
    }

    bairroEntrega(data: any): string {
        return this.valorPrimeiro(data, ['BAIRROENTREGA', 'NOMEBAIENTREGA', 'NOMEBAI']) || '________________';
    }

    cidadeUfEntrega(data: any): string {
        const cidade = this.valorPrimeiro(data, ['CIDADEENTREGA', 'NOMECIDENTREGA', 'NOMECID']);
        const uf = this.valorPrimeiro(data, ['UFENTREGA', 'UF']);
        return [cidade, uf].filter(Boolean).join('-') || '________________';
    }

    cepEntrega(data: any): string {
        return this.formatarCep(this.valorPrimeiro(data, ['CEPENTREGA', 'CEP'])) || '________________';
    }

    emailEntrega(data: any): string {
        return this.valorPrimeiro(data, ['EMAILENTREGA', 'EMAILPARC', 'EMAIL']) || '';
    }

    fonesEntrega(data: any): string {
        return this.formatarTelefones(this.valorPrimeiro(data, ['FONEENTREGA', 'TELEFONEENTREGA', 'TELPARC', 'TELEFONE', 'FONE'])) || '________________';
    }

    observacao(data: any): string {
        const texto = this.valorPrimeiro(data, ['OBSERVACAO', 'OBS', 'AD_OBSERVACAO']) || '';
        return texto
            .replace(/Prefixo\s*:\s*[^.]*\.?/gi, '')
            .replace(/Cert\.\(COM\)\s*:\s*[^.]*\.?/gi, '')
            .trim();
    }

    codigoEmpresa(data: any): string {
        return this.valorPrimeiro(data, ['CODEMP', 'CODEMPRESA', 'EMPRESA']) || '0000001';
    }

    usuarioAtual(data: any): string {
        return this.valorPrimeiro(data, ['NOMEUSU', 'USUARIO', 'CODUSU']) || '-';
    }

    dataAtual(): string {
        return new Date().toLocaleDateString('pt-BR');
    }

    horaAtual(): string {
        return new Date().toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }

    private async respostaGateway<T = any>(observable: any): Promise<T> {
        const value: any = await firstValueFrom(observable);
        if (!value) throw new Error('Resposta vazia do gateway.');
        if (value.status && value.status !== '1') throw new Error(value.statusMessage || 'Service nao retornou sucesso.');
        return (value.responseBody || value) as T;
    }

    private valorBusca(objeto: any, key: string): string {
        const value = objeto?.[key];
        return value === null || value === undefined ? '' : String(value);
    }

    private valorPrimeiro(objeto: any, keys: string[]): string {
        for (const key of keys) {
            const value = this.valor(objeto, key).trim();
            if (value) return value;
        }

        return '';
    }

    private removerClientesDuplicados(lista: unknown): any[] {
        if (!Array.isArray(lista)) return [];

        const vistos = new Set<string>();
        const clientes: any[] = [];

        for (const cliente of lista) {
            const doc = this.valorBusca(cliente, 'docparc') || this.valorBusca(cliente, 'DOCPARC') || this.valorBusca(cliente, 'CNPJ') || this.valorBusca(cliente, 'CGC_CPF');
            const codparc = this.valorBusca(cliente, 'codparc') || this.valorBusca(cliente, 'CODPARC');
            const chave = doc.replace(/\D/g, '') || `CODPARC:${codparc}`;

            if (!chave || vistos.has(chave)) continue;
            vistos.add(chave);
            clientes.push(cliente);
        }

        return clientes;
    }

    private formatarDocumento(doc: string): string {
        const digitos = String(doc || '').replace(/\D/g, '');
        if (digitos.length === 14) return digitos.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
        if (digitos.length === 11) return digitos.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
        return doc || '';
    }

    private formatarCep(cep: string): string {
        const digitos = String(cep || '').replace(/\D/g, '');
        if (digitos.length === 8) {
            return digitos.replace(/^(\d{5})(\d{3})$/, '$1-$2');
        }
        return cep || '';
    }

    private formatarTelefones(valor: string): string {
        const texto = String(valor || '').trim();
        if (!texto) return '';

        const partes = texto.includes('/') || texto.includes(';')
            ? texto.split(/[\/;]/)
            : [texto];

        return partes
            .map((parte) => this.formatarTelefone(parte))
            .filter(Boolean)
            .join(' / ');
    }

    private formatarTelefone(valor: string): string {
        const digitos = String(valor || '').replace(/\D/g, '');
        if (digitos.length === 11) {
            return digitos.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
        }
        if (digitos.length === 10) {
            return digitos.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
        }
        if (digitos.length === 8) {
            return digitos.replace(/^(\d{4})(\d{4})$/, '$1-$2');
        }
        return valor || '';
    }

    private diasAntes(data: Date, dias: number): Date {
        const dataCalculada = new Date(data);
        dataCalculada.setDate(data.getDate() - dias);
        return dataCalculada;
    }

    private formatarDataInput(data: Date): string {
        const ano = data.getFullYear();
        const mes = String(data.getMonth() + 1).padStart(2, '0');
        const dia = String(data.getDate()).padStart(2, '0');
        return `${ano}-${mes}-${dia}`;
    }

    private money(number: any): string {
        return Number(number || 0).toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }
}
